import { US_PHONE_DIGITS } from '@features/auth/phoneNumber';
import { z } from 'zod';

export const SELLER_TYPES = ['PRIVATE', 'DEALER'] as const;

export const contactDetailsSchema = z.object({
  contactType: z.enum(SELLER_TYPES),
  contactName: z.string().trim().min(2, 'validation.contactNameRequired'),
  contactPhone: z
    .string()
    .min(1, 'validation.phoneRequired')
    .regex(new RegExp(`^\\d{${US_PHONE_DIGITS}}$`), 'validation.phoneInvalid'),
  contactEmail: z
    .string()
    .trim()
    .min(1, 'validation.emailRequired')
    .pipe(z.email('validation.emailInvalid')),
  instruction: z.string(),
});

export type ContactFormValues = z.infer<typeof contactDetailsSchema>;
